namespace Gamification.Gamification {
    export interface AssetEsperienzeForm {
        IdAssetEsperienza: Serenity.IntegerEditor;
        UserId: Serenity.IntegerEditor;
        TenantId: Serenity.IntegerEditor;
        IsCloned: Serenity.IntegerEditor;
        IdAssetEsperienzaOriginal: Serenity.IntegerEditor;
        TemporaryNomeFileAssetBundle: Serenity.StringEditor;
        TemporaryPathFileAssetBundle: Serenity.StringEditor;
        TemporaryNomeFileCoverAssetBundle: Serenity.StringEditor;
        TemporaryPathFileCoverAssetBundle: Serenity.StringEditor;
        TemporaryNomeFileManifestAssetBundle: Serenity.StringEditor;
        TemporaryPathFileManifestAssetBundle: Serenity.StringEditor;
        IdDispositivo: Serenity.LookupEditor;
        IdTipologiaEsperienza: Serenity.LookupEditor;
        IdentifierAssetEsperienza: Serenity.StringEditor;
        Nome: Serenity.StringEditor;
        VersioneAssetBundle: Serenity.IntegerEditor;
        NomeFileAssetBundle: Serenity.StringEditor;
        PathFileAssetBundle: Serenity.ImageUploadEditor;
        UrlAssetBundle: Serenity.StringEditor;
        NomeFileCoverAssetBundle: Serenity.StringEditor;
        PathFileCoverAssetBundle: Serenity.ImageUploadEditor;
        UrlCoverAssetBundle: Serenity.StringEditor;
        NomeFileManifestAssetBundle: Serenity.StringEditor;
        PathFileManifestAssetBundle: Serenity.ImageUploadEditor;
        UrlManifestAssetBundle: Serenity.StringEditor;
        ProdottiClassiList: ProdottiClassiAssetEsperienze2Editor;
        ChecklistList: Checklist2Editor;
        RisorseList: AssetEsperienzeRisorse2Editor;
    }

    export class AssetEsperienzeForm extends Serenity.PrefixedContext {
        static formKey = 'Gamification.AssetEsperienze';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!AssetEsperienzeForm.init)  {
                AssetEsperienzeForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;
                var w2 = s.LookupEditor;
                var w3 = s.ImageUploadEditor;
                var w4 = ProdottiClassiAssetEsperienze2Editor;
                var w5 = Checklist2Editor;
                var w6 = AssetEsperienzeRisorse2Editor;

                Q.initFormType(AssetEsperienzeForm, [
                    'IdAssetEsperienza', w0,
                    'UserId', w0,
                    'TenantId', w0,
                    'IsCloned', w0,
                    'IdAssetEsperienzaOriginal', w0,
                    'TemporaryNomeFileAssetBundle', w1,
                    'TemporaryPathFileAssetBundle', w1,
                    'TemporaryNomeFileCoverAssetBundle', w1,
                    'TemporaryPathFileCoverAssetBundle', w1,
                    'TemporaryNomeFileManifestAssetBundle', w1,
                    'TemporaryPathFileManifestAssetBundle', w1,
                    'IdDispositivo', w2,
                    'IdTipologiaEsperienza', w2,
                    'IdentifierAssetEsperienza', w1,
                    'Nome', w1,
                    'VersioneAssetBundle', w0,
                    'NomeFileAssetBundle', w1,
                    'PathFileAssetBundle', w3,
                    'UrlAssetBundle', w1,
                    'NomeFileCoverAssetBundle', w1,
                    'PathFileCoverAssetBundle', w3,
                    'UrlCoverAssetBundle', w1,
                    'NomeFileManifestAssetBundle', w1,
                    'PathFileManifestAssetBundle', w3,
                    'UrlManifestAssetBundle', w1,
                    'ProdottiClassiList', w4,
                    'ChecklistList', w5,
                    'RisorseList', w6
                ]);
            }
        }
    }
}
